<template>
  <div class="md-layout">
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-50 md-size-50">
      <div @click="gotoRoute('messages')">
        <stats-card header-color="primary">
          <template slot="header">
            <div class="card-icon">
              <i class="fa fa-envelope" />
            </div>
            <p class="category"><span style="color: #777; font-size:.85rem;" /></p>
            <h3 class="title">
              <animated-number :value="numMessages" />
            </h3>
          </template>

          <template slot="footer">
            <div class="stats" style="font-weight:400; font-size:.9rem;">
              <!--<md-icon>update</md-icon>-->
              My Messages
            </div>
          </template>
        </stats-card>
      </div>
    </div>

    <div class="md-layout-item md-medium-size-50 md-xsmall-size-50 md-size-50">
      <div @click="gotoRoute('screenings')">
        <stats-card header-color="primary">
          <template slot="header">
            <div class="card-icon">
              <!--<md-icon>equalizer</md-icon>-->
              <i class="fa fa-eye" />
            </div>
            <p class="category"><span style="color: #777; font-size:.85rem;" /></p>
            <h3 class="title">
              <animated-number :value="numAvailable" />
            </h3>
          </template>

          <template slot="footer">
            <div class="stats" style="font-weight:400; font-size:.9rem;">
              <!-- <md-icon>local_offer</md-icon>-->
              My Screenings
            </div>
          </template>
        </stats-card>
      </div>
    </div>

    <div class="md-layout-item md-size-100">
      <globe-activity-slim-card header-color="green">
        <template slot="header">
          <div class="card-icon">
            <md-icon>language</md-icon>
          </div>
          <h4 class="title">Globe Activity</h4>
        </template>

        <template slot="content">
          <div class="md-layout">
            <div class="md-layout-item" align="Left">
              <globe-activity-slim-table />
            </div>
          </div>
        </template>
      </globe-activity-slim-card>
    </div>
  </div>
</template>

<script>
import { StatsCard, AnimatedNumber } from "@/components"
import GlobeActivitySlimCard from "@/components/GlobeChek/Cards/GlobeActivitySlimCard.vue"
import GlobeActivitySlimTable from "@/components/GlobeChek/Tables/GlobeActivitySlimTable.vue"
import axios from 'axios'

export default {
  components: {
    StatsCard,
    AnimatedNumber,
    GlobeActivitySlimCard,
    GlobeActivitySlimTable
  },
  data() {
    return {
      nMessages: 0,
      nAvailable: 0,
      nOnHold: 0,
      nReports: 0
    }
  },
  computed: {
    numMessages() {
      return sessionStorage.getItem("technicianMessages")
    },
    numAvailable() {
      return sessionStorage.getItem("technicianAvailable")
    }
  },
  created: function() {
    // this.$store.dispatch('loadReaderInfo')
  },
  mounted: function() {
    this.$nextTick(function() {
      this.initDash()
      //this.renderComponent = true;
    })
  },
  methods: {
    gotoRoute(r) {
      this.$router.push("/portal/technician/" + r)
    },

    initDash() {
      this.getDashboardInfo("/technician-dash/", sessionStorage.getItem("username"))

      this.nMessages = sessionStorage.getItem("technicianMessages")
      this.nAvailable = sessionStorage.getItem("technicianAvailable")
    },

    async getDashboardInfo(route, user, kiosk, email) {
      const url = process.env.VUE_APP_URL + route + user
      const config = { headers: { "Content-Type": "application/json" } }
      const data = null
      var vm = this
      await window.axios

        .get(url, data, config)
        .then(r => r.data)
        .then(response => {
          vm.updtDash(response)
        })
        .catch(function(error) {
          vm.status = "An error occurred: " + error
          //console.log(vm.status);
        })
    },

    updtDash(values) {
      var res = values.split(",")
      sessionStorage.setItem("technicianMessages", res[0])
      sessionStorage.setItem("technicianAvailable", res[1])
    }
  }
}
</script>
